import { LanePollDataActionTypes, AddLanePollData, ModifyLanePollData, DeleteLanePollData } from 'Actions/ActionTypes/index';
import { Id, LanePollData } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines methods that create action objects for Lane Poll Data
 * in the store
 */

export const addLanePollData = (lanePollData: LanePollData[]): AddLanePollData => ({
    type: LanePollDataActionTypes.AddLanePollData as LanePollDataActionTypes.AddLanePollData,
    lanePollData
});


export const modifyLanePollData = (lanePollData: LanePollData[] ): ModifyLanePollData => ({
    type: LanePollDataActionTypes.ModifyLanePollData as LanePollDataActionTypes.ModifyLanePollData,
    lanePollData
});

export const deleteLanePollData = (ids: Id[]): DeleteLanePollData => ({
    type: LanePollDataActionTypes.DeleteLanePollData as LanePollDataActionTypes.DeleteLanePollData,
    ids
});

export type LanePollDataAction = ReturnType<typeof addLanePollData | typeof modifyLanePollData | typeof deleteLanePollData>